import { render, staticRenderFns } from "./fkFanQi.vue?vue&type=template&id=e1fdc84c&"
import script from "./fkFanQi.vue?vue&type=script&lang=js&"
export * from "./fkFanQi.vue?vue&type=script&lang=js&"
import style0 from "./fkFanQi.vue?vue&type=style&index=0&id=e1fdc84c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports